// ============================================
// PUBLIC HOLIDAYS CONFIGURATION
// ============================================
// Format: YYYY-MM-DD
// ============================================

const PUBLIC_HOLIDAYS_CONFIG = {

  '2026': [
    '2026-01-01',
    '2026-01-19',
    '2026-02-16',
    '2026-05-12',
    '2026-07-03',
    '2026-05-21',
    '2026-06-25',
    '2026-08-15',
    '2026-10-12',
    '2026-11-11',
    '2026-11-26',
    '2026-11-27',
    '2026-12-24',
    '2026-12-25',
    '2026-12-31',
  ],

  '2027': [
    '2027-01-01',
    '2027-01-18',
    '2027-02-15',
    '2027-05-31',
    '2027-07-04',
    '2027-07-05',
    '2027-09-06',
    '2027-10-11',
    '2027-11-11',
    '2027-11-25',
    '2027-11-26',
    '2027-12-24',
    '2027-12-25',
    '2027-12-31',
  ],

  '2028': [
    '2028-01-01',
    '2028-01-17',
  ]
};


// ============================================
// HELPERS
// ============================================

// Format date safely in local timezone
function formatDateString(date) {
  return [
    date.getFullYear(),
    String(date.getMonth() + 1).padStart(2, '0'),
    String(date.getDate()).padStart(2, '0')
  ].join('-');
}


// Check if date is a holiday
function isHoliday(date) {

  const dateStr = formatDateString(date);
  const year = date.getFullYear().toString();

  return (
    PUBLIC_HOLIDAYS_CONFIG[year] &&
    PUBLIC_HOLIDAYS_CONFIG[year].includes(dateStr)
  );
}


// Working day = not Sunday + not holiday
function isWorkingDay(date) {
  return date.getDay() !== 0 && !isHoliday(date);
}


// Move to next valid working day
function moveToNextWorkingDay(date, startHour = 10) {

  while (!isWorkingDay(date)) {
    date.setDate(date.getDate() + 1);
  }

  date.setHours(startHour, 0, 0, 0);

  return date;
}


// Add working days
function addWorkingDays(startDate, daysToAdd) {

  let result = new Date(startDate);
  let daysAdded = 0;

  while (daysAdded < daysToAdd) {

    result.setDate(result.getDate() + 1);

    if (isWorkingDay(result)) {
      daysAdded++;
    }
  }

  return result;
}